var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "form-data-table" } }, [
      _c("div", { staticClass: "form-data-table" }, [
        _c("h3", [_vm._v("Veri Tablosu")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }